// extracted by mini-css-extract-plugin
export default {"imageContainer":"l0-z","summaryPar":"m0-z","ratingCategories":"n0-z","reviewerInfo":"o0-z","reviewTypes":"p0-z","expanded":"q0-z"};